import { useState, useEffect, useRef, useMemo } from "react"
import { useParams, useHistory } from 'react-router-dom'
import { useLocation } from "react-router"
import Grid from '@material-ui/core/Grid'
import AddIcon from '@material-ui/icons/Add'
import Autocomplete from '@material-ui/lab/Autocomplete'

import CheckBox from "@base/Inputs/CheckBox/CheckBox"
import Title from '@base/Title'
import Filter from '@base/Filter'
import TextField from '@base/Inputs/Text'
import SelectOption from '@base/Inputs/Select'
import ButtonPrimary from '@base/Button'
import Toast from '@base/Toast'
import { ProcessoResolver } from "@helpers/ProcessoHelper"
import PendenciaService from '@services/PendenciaService'
import PendenciaTableView from "@pages/Pendencia/PendenciaTableView"
import DialogConfirm from '@base/Dialog/DialogConfirm'

import AuthorizedElement from '@security/AuthorizedElement';

import useStatusPendencia from "@hooks/enums/useStatusPendencia";
import useTipoPendencia from "@hooks/enums/useTipoPendencia";
import useColaboradores from "@hooks/enums/useColaboradores"

export const Pendencia = () => {

  const processo = ProcessoResolver(useParams().processo);

  const listagemStatus = useStatusPendencia();
  const listagemTipoPendencia = useTipoPendencia(processo.id);
  const listagemColaboradores = useColaboradores(processo.id);

  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroSomentePendenciasNaoResolvidas, setFiltroSomentePendenciasNaoResolvidas] = useState(false);

  
  const [filtroCodigoCaixa, setFiltroCodigoCaixa] = useState('');
  const [filtroTipoPendencia, setFiltroTipoPendencia] = useState("");
  const [filtroStatusPendencia, setFiltroStatusPendencia] = useState("");
  const [filtroUsuarioTratamento, setFiltroUsuarioTratamento] = useState("");
  const [filtroINEP, setFiltroINEP] = useState("");
  const [filtroObjetoPostal, setFiltroObjetoPostal] = useState("");
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);
  const [listaDePendenciasMarcadas, setListaDePendenciasMarcadas] = useState([]);

  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [dialogConfirmText, setDialogConfirmText] = useState("");
  const [dialogConfirmTitle, setDialogConfirmTitle] = useState("");
  const [dialogConfirmAction, setDialogConfirmAction] = useState(() => null);

  const toastRef = useRef(null);

  const pageName = 'Tratamento de Pendências';

  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQuery();

  const aplicarFiltros = (ativo = false) => {
    let f = [];

    if (filtroTipoPendencia) f.push({ field: 'tipoPendencia', value: filtroTipoPendencia });
    if (filtroStatusPendencia) f.push({ field: 'statusPendencia', value: filtroStatusPendencia });
    if (filtroUsuarioTratamento) f.push({ field: 'usuarioTratamento', value: filtroUsuarioTratamento });
    if (filtroINEP) f.push({ field: 'inep', value: filtroINEP });
    if (filtroObjetoPostal) f.push({ field: 'objetoPostal', value: filtroObjetoPostal });
    if (filtroSomentePendenciasNaoResolvidas) f.push({ field: 'somentePendenciasNaoResolvidas', value: filtroSomentePendenciasNaoResolvidas });    
    if (filtroCodigoCaixa) f.push({ field: 'codigoCaixa', value: filtroCodigoCaixa });

    setFiltros(f);
    setFiltroAtivo(ativo);
    setQuantidadeFiltrosAplicados(f.length);
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setFiltros([]);
    setFiltroAtivo(false);
    setFiltroCodigoCaixa('');
    setFiltroTipoPendencia('');
    setFiltroStatusPendencia('');
    setFiltroUsuarioTratamento('');
    setFiltroINEP('');
    setFiltroObjetoPostal('');
    setQuantidadeFiltrosAplicados(0);
  }

  const history = useHistory();
  const buttonAdd = () =>

        <ButtonPrimary style={{float:"right"}}
          onClick={() => history.push("/" + processo.id + "/pendencias/registrar")}
          name="Registrar Nova Pendência"
          startIcon={<AddIcon />}
        />

  useEffect(() => {
      if (query.get("somentePendenciasNaoResolvidas")) {
        const f = [];
        f.push({ field: 'somentePendenciasNaoResolvidas', value: true });
  
        setFiltroSomentePendenciasNaoResolvidas(true);
        setFiltros(f);
      }
    }, [query])

  const handleMarcarPendencia = (ids) => setListaDePendenciasMarcadas(ids);

  const closeDialog = () => {
    setDialogConfirmTitle("")
    setDialogConfirmText("");
    setDialogConfirmAction(() => null);
    setOpenDialogConfirm(false);
  }

  const openDialog = (title, text, action) => {
    setDialogConfirmTitle(title)
    setDialogConfirmText(text);
    setDialogConfirmAction(() => action);
    setOpenDialogConfirm(true);
  }

  const handleResolverTodas = () => {
    if(listaDePendenciasMarcadas.length === 0) {
      toastRef.current.show("warning", "Nenhuma pendência foi selecionada para ser Resolvida.");
      setOpenDialogConfirm(false);
    } else {
      PendenciaService.resolverEmLote(processo.id, "RESOLVIDA", {"ids" : listaDePendenciasMarcadas}).then(resultado => {
        toastRef.current.show("success", "Todas as Pendências Foram Resolvidas com Sucesso.");
        aplicarFiltros(true);
      }).catch(erro => {
        toastRef.current.show("error", "Não foi possível resolver as Pendências: " + erro.response.data.mensagens.map(m => m).join(" ,"));
      }).finally(() => setOpenDialogConfirm(false));
    }
  }

  return (
    <>
      <Toast ref={toastRef} />

      <Title>{pageName}  {buttonAdd()}</Title>
      <br />

      <Filter
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={4}>
          <Grid item sm={12} lg={5}>
            <SelectOption
              label='Tipo'
              value={filtroTipoPendencia}
              name='filtroTipoPendencia'
              onChange={(e) => setFiltroTipoPendencia(e.target.value)}
              options={listagemTipoPendencia.data}
            />
          </Grid>
          <Grid item sm={12} lg={3}>
            <SelectOption
              label='Status'
              value={filtroStatusPendencia}
              name='filtroStatusPendencia'
              onChange={(e) => setFiltroStatusPendencia(e.target.value)}
              options={listagemStatus.data}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={4}>
          <Grid item sm={12} lg={2}>
            <TextField
              label='INEP'
              value={filtroINEP}
              name='filtroINEP'
              inputProps={{ maxLength: 8 }}
              onChange={(e) => setFiltroINEP(e.target.value.trim())}
            />
          </Grid>

          <Grid item sm={12} lg={2}>
            <TextField
              label='Objeto Postal'
              value={filtroObjetoPostal}
              name='filtroObjetoPostal'
              inputProps={{ maxLength: 13 }}
              onChange={(e) => setFiltroObjetoPostal(e.target.value.trim())}
            />
          </Grid>

          <Grid item sm={6} lg={2}>
						<TextField
							label='Código da Caixa'
							value={filtroCodigoCaixa}
							name='filtroCodigoCaixa'
							onChange={(e) => setFiltroCodigoCaixa(e.target.value.trim())}
						/>
          </Grid>
        </Grid>
        <Grid item container spacing={4}>
          <Grid item sm={12} lg={4}>
            <Autocomplete
              name='filtroUsuarioTratamento'
              value={filtroUsuarioTratamento != null ? filtroUsuarioTratamento.label : null}
              onChange={(e, obj) => setFiltroUsuarioTratamento(obj != null ? obj.value : null)}
              options={listagemColaboradores.data}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} label='Usuário do Tratamento' />}
              openText={`Abrir`}
              clearText={`Limpar`}
            />
          </Grid>
        </Grid>
 <Grid item container>
            <Grid item sm={12} lg={12}>
              <CheckBox
                label='Somente pendências não resolvidas (Pendente, Em tratamento)'
                checked={filtroSomentePendenciasNaoResolvidas}
                name='filtroSomentePendenciasNaoResolvidas'
                onChange={(e) => setFiltroSomentePendenciasNaoResolvidas(e.target.checked)}
              />
            </Grid>
          </Grid>

      </Filter>

      <PendenciaTableView
        processo={processo.id}
        filtros={filtros}
        filtroAtivo={filtroAtivo}
        setFiltroAtivo={setFiltroAtivo}
        handleMarcarPendencia={handleMarcarPendencia}
      />

      <Grid container spacing={3} >
        <Grid item xs={2} >
          <AuthorizedElement roles={["Administrador"]} >
            <ButtonPrimary style={{marginLeft:5}}
              onClick={() => openDialog("Ïmportante", "As Pendências Selecionadas Serão Tratadas como Resolvidas", handleResolverTodas) }
              name="Resolver"
            />
            </AuthorizedElement>
        </Grid>
      </Grid>



      {openDialogConfirm &&
				<DialogConfirm
					maxWidth={"sm"}
					text={dialogConfirmText}
					close={() => closeDialog(false)}
					open={openDialogConfirm}
					title={dialogConfirmTitle}
					handleConfirm={dialogConfirmAction}
				/>
			}
    </>
  );
}

export default Pendencia;
